<template>
  <article :class="[$style.block, reversed ? $style.reversed : '']">
    <h4 data-anim="stagger" :class="'line-title'" v-html="title"></h4>
    <p data-anim="stagger" :class="$style.content" v-html="content"></p>
  </article>
</template>

<script>
export default {
  props: ['content', 'title', 'reversed', 'icons']
}
</script>

<style lang="scss">
@import "~sass-mq/mq";

.line-title {
  max-width: 400px;
  width: 100%;
  position: relative;
  margin-bottom: $small-margin;
  display: inline-block;

  font-size: font-size(s);
  color: $color-blue;
  letter-spacing: 2.5px;
  font-weight: 800;
  text-transform: uppercase;

  &::before {
    content: "";
    width: $line-width-mobile;
    height: 1px;
    background: $color-gray-brown;
    position: absolute;
    top: 8px;
    right: 100%;
    margin: auto 10px;

    @include mq(sm) {
      width: $line-width;
    }

    transform: scaleX(0);
    transition: transform 0.3s cubic-bezier(.17,.67,.59,.85) 0.6s;
    transform-origin: 0% 0%;
  }

  &[data-animated]::before {
    transform: scaleX(1);
  }

  &__dark {
    &::before {
      background: $color-dark;
    }
  }
}
</style>


<style lang="scss" module>
@import "~sass-mq/mq";

.block {
  position: relative;
  display: inline-flex;
  flex-flow: column;
  z-index: 1;
  width: 100%;
  padding-right: $standard-margin-mobile;

  @include mq(sm) {
    padding-right: $standard-margin;
  }


  h4,
  p {
    opacity: 0;
  }

  :global {
    .lines {
      @include boost-performance();
      display: inline-block;
      transform-origin: 0;
    }
  }

  @include mq(sm) {
    &.reversed {
      // align-items: flex-end;
      text-align: left;

      padding-right: 0;
      padding-left: $standard-margin;

      :global .lines {
        transform-origin: 100%;
      }

      .title::before {
        right: auto;
        left: 100%;
      }
    }
  }
}

.content, {
  max-width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/TextBlock.vue